export default __webpack_public_path__ + "static/media/blog-post.344a0604.jpg";